import React, { useEffect, useState } from 'react';

import { toast } from 'react-toastify';
import { Dialog, DialogActions, DialogContent, DialogTitle, FormControl, InputLabel, MenuItem, Select } from '@material-ui/core';
import PropTypes from 'prop-types';

import { IsArray, IsEmpty } from '../../../../common/checks';
import { Status } from '../../../../common/constants';
import MText from '../../../../components/Common/MText';
import MButton from '../../../../components/MButton';
import Colours from '../../../../styles/colours';
import OverLoading from '../../../../components/Loading';
import ApiService from '../../../../services/apiService';

const Mode = {
  Single:   'Single',
  Multiple: 'Multiple',
};

const UpdatePromoCodeModal = (props) => {
  const [status, setStatus] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const singleUpdatePromoCode = async (id, data) => {
    // eslint-disable-next-line no-useless-catch
    try {
      await ApiService.updatePromoCode(props.pageId, id, data);
    } catch (error) {
      toast.error('Failed to update promo codes');
      toast.error(error.message);
    }
  };

  const bulkUpdatePromoCodes = async (promoCodesId, data) => {
    // eslint-disable-next-line no-useless-catch
    try {
      await ApiService.bulkUpdatePromoCodes(props.pageId, {
        ids: promoCodesId,
        ...data,
      });
    } catch (error) {
      toast.error('Failed to update promo codes');
      toast.error(error.message);
    }
  };

  const handlePromoCodeUpdate = async () => {
    try {
      setIsLoading(true);
      if (props.mode === Mode.Single) {
        await singleUpdatePromoCode(props.selectedPromoCode.id, { status });
        props.onClose();
      } else if (props.mode === Mode.Multiple) {
        await bulkUpdatePromoCodes(props.selectedPromoCodesId, { status });
        props.onClose();
      }
      props.onComplete();
    } catch (error) {
      toast.error('Failed to update promo codes');
      toast.error(error.message);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    setStatus(null);
  }, [props.selectedPromoCode, props.mode]);

  if (
    (props.mode === Mode.Single && IsEmpty(props.selectedPromoCode)) || (props.mode === Mode.Multiple && !IsArray(props.selectedPromoCodesId))
  ) {
    return null;
  }

  return (
    <>
      <Dialog
        open={props.isModalOpen}
        fullWidth
        maxWidth="xs"
        onClose={props.onClose}
      >
        { isLoading && <OverLoading />}
        <DialogTitle>
          <MText size={14} text="Status Update" />
        </DialogTitle>
        <DialogContent>
          <div>
            {
              !IsEmpty(props.selectedPromoCodesId) && (
                <MText className="" size={13} bold>
                  {props.selectedPromoCodesId.length}
                  {' '}
                  promo codes selected
                </MText>
              )
            }

            <FormControl className="mt-3" style={{ width: '100%' }}>
              <InputLabel shrink>
                Update to:
              </InputLabel>
              <Select
                value={status}
                onChange={(e) => setStatus(e.target.value)}
              >
                <MenuItem value={Status.Deactivated}><MText text={Status.Deactivated} size={13} /></MenuItem>
                <MenuItem value={Status.Redeemed}><MText text={Status.Redeemed} size={13} /></MenuItem>
              </Select>
            </FormControl>
          </div>
        </DialogContent>

        <DialogActions className="mt-3 mr-3 mb-4">
          <div className="d-flex flex-row justify-content-end" style={{ columnGap: 12 }}>
            <MButton variant="outlined" onClick={props.onClose} text="Cancel" />
            <MButton
              className="ml-4"
              disabled={IsEmpty(status) || isLoading}
              text="Update"
              textColour={Colours.White}
              variant="outlined"
              colour={(IsEmpty(status) || isLoading) ? Colours.LightGray2 : Colours.Secondary}
              onClick={handlePromoCodeUpdate}
            />
          </div>
        </DialogActions>
      </Dialog>
    </>
  );
};

UpdatePromoCodeModal.propTypes = {
  selectedPromoCode: PropTypes.shape({
    id:     PropTypes.number,
    status: PropTypes.oneOf([
      Status.Activated,
      Status.Deactivated,
      Status.Redeemed,
      Status.Unredeemed,
    ]),
  }),
  pageId:               PropTypes.number.isRequired,
  selectedPromoCodesId: PropTypes.arrayOf(PropTypes.number),
  isModalOpen:          PropTypes.bool.isRequired,
  onClose:              PropTypes.func.isRequired,
  onComplete:           PropTypes.func,
  mode:                 PropTypes.oneOf([Mode.Single, Mode.Multiple]).isRequired,
};

UpdatePromoCodeModal.defaultProps = {
  selectedPromoCode:    {},
  selectedPromoCodesId: [],
  onComplete:           () => { },
};

export default UpdatePromoCodeModal;
